<template>
  <Layout>
    <DefaultHeader slot="header" />

    <div>
      <nuxt />
    </div>
  </Layout>
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader'
import Layout from '@/components/Layout'

export default {
  components: { DefaultHeader, Layout },
}
</script>
